export default __webpack_public_path__ + "static/media/pic01.66aada22.jpg";